import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';

@Component({
  selector: 'ui-checkbox-row',
  imports: [],
  templateUrl: './ui-checkbox-row.component.html',
  styleUrl: './ui-checkbox-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCheckboxRowComponent {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly description: InputSignal<string | null> = input<string | null>(null);
  public readonly checked: InputSignal<boolean> = input<boolean>(false);
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly ariaLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly checkedChange: OutputEmitterRef<boolean> = output<boolean>();

  protected readonly hasDescription: Signal<boolean> = computed((): boolean => !!this.description());
  protected readonly accessibleLabel: Signal<string> = computed((): string => this.ariaLabel() ?? this.title());

  protected handleToggle(event: MouseEvent): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }

    this.checkedChange.emit(!this.checked());
  }
}
